import {request} from '../request'


/**
 * 获取退货的订单信息
 * @returns {AxiosPromise}
 * @constructor
 */
export function CommodityInfor(params) {
    return request({
        url: "/agg-portal/ap/returnApply/commodityInfor",
        method: 'POST',
        params: params
    });
}

/**
 * 获取退货地址
 */
export function getrefundAdderss(id) {
    return request({
        url: '/agg-portal/ap/returnReason/getrefundAdderss',
        method: 'post',
        params: {
            id:id
        }
    })
}

/**
 * 获取可以申请退款的商品
 */
export function getrefundGoods(condition){
    return request({
        url: '/agg-portal/ap/returnApply/afterSaleList',
        method: 'post',
        params: condition
    })

}

/**
 * 获取可以申请退款的商品
 */
export function setLogisticsNumber(params){
    return request({
        url: '/agg-portal/ap/returnApply/setLogisticsNumber',
        method: 'post',
        params: params
    })

}

/**
 * 判断商品是否是 退货商品
 */
export function eligibleGoods(params){
    return request({
        url: '/agg-portal/ap/returnApply/eligibleGoods',
        method: 'get',
        params: {
            order:params
        }
    })

}
